import { SBImage } from '@/components/ImageService/SBImage';
import { Mindentity } from '@/components/Mindentity/Mindentity';
import { Typography } from '@/shared';
import { useBreakpoints } from '@/shared/providers/Device';
import { MindStoryblok } from '@/shared/types/storyblok/storyblok-types';
import { Icon } from '@/shared/ui/Icon/Icon';
import clsx from 'clsx';
import styles from './MindCard.module.scss';

type MindCardProps = {
    element: MindStoryblok;
    onClick: () => void;
    isDark: boolean;
    children?: any;
    isActive?: boolean;
    uniqueId?: string;
};
const MindCard = ({ element, onClick, isDark, isActive, children, uniqueId }: MindCardProps) => {
    const { isXXSmall, isExtraSmall, isSmall } = useBreakpoints();
    const isMobile = isXXSmall || isExtraSmall || isSmall;

    if (!element || !element.content) return null;

    const { fullname, portrait, role, mind_color } = element.content;
    const joinedRole = (role: string | string[]) => (Array.isArray(role) ? role.join(' & ') : role);

    const handleClick = () => {
        if (isActive) return;
        onClick();
    };

    return (
        <div
            className={clsx(styles.card, {
                [styles.dark]: isDark,
                [styles.active]: isActive,
            })}
            onClick={handleClick}
            id={`${uniqueId + element.id}`}
        >
            {children ? (
                children
            ) : (
                <>
                    <div className={styles.topCard}>
                        <div>
                            {!isMobile && (
                                <Mindentity name={fullname || ''} color={mind_color?.color} isDark={isDark}>
                                    <SBImage image={portrait} height={280} />
                                </Mindentity>
                            )}
                            {isMobile && <SBImage image={portrait} height={280} />}
                        </div>
                        <div className={styles.info}>
                            <Typography.H3 className={styles.title}>{fullname}</Typography.H3>
                            <Typography.Small className={styles.description}>{joinedRole(role)}</Typography.Small>
                        </div>
                    </div>
                    <div className={styles.icon}>
                        <Icon name={isActive ? 'less' : 'plus'} className={styles.plus} />
                    </div>
                </>
            )}
        </div>
    );
};

export default MindCard;
